module.exports = __webpack_public_path__ + "static/media/chat.37ad9ecf.svg";